"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var remove_ships_every_text_1 = __importDefault(require("../../../../../utils/remove-ships-every-text"));
var index_1 = require("../index");
exports.default = (function () {
    var _a = (0, react_1.useContext)(index_1.AppContext), cancelReason = _a.cancelReason, resetToFirstStep = _a.resetToFirstStep, refundType = _a.refundType, setRefundType = _a.setRefundType, mainBundleProduct = _a.mainBundleProduct;
    if (!cancelReason || cancelReason.key === '') {
        resetToFirstStep();
    }
    // list of disabled refund types
    // when enabling or disabling, be sure to also reflect changes in subscriptions-api in cancel-order.ts
    var disabledRefundTypes = ['giftCard'];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        mainBundleProduct && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'grid-x bg-white padding-5' },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("img", { src: mainBundleProduct.image_src, style: { maxHeight: '50px' } })),
                react_1.default.createElement("div", { className: 'cell auto padding-left-5', style: { margin: 'auto' } },
                    react_1.default.createElement("div", null, (0, remove_ships_every_text_1.default)(mainBundleProduct.title)),
                    react_1.default.createElement("div", { className: 'text-brownish-grey font-size-small' },
                        "Reason: ", cancelReason === null || cancelReason === void 0 ? void 0 :
                        cancelReason.name))))),
        react_1.default.createElement("div", { className: 'padding-5' },
            react_1.default.createElement("h3", null, "How can we make it right?"),
            react_1.default.createElement("div", { className: 'text-brownish-grey padding-top-3 font-size-14' }, "Information about initiating return and some marketing copy goes here to talk about whatever"),
            react_1.default.createElement("div", { className: 'padding-top-5' }, (function () {
                return [
                    {
                        key: 'giftCard',
                        name: 'Receive refund as gift credit',
                        opts: {
                            flag: 'Most Popular',
                            description: 'Receive a gift code to repurchase your order after it is cancelled',
                        },
                    },
                    {
                        key: 'creditCard',
                        name: 'Receive full refund to original purchase method',
                    },
                ].map(function (option) {
                    var _a, _b, _c;
                    var isActive = refundType === option.key;
                    return (react_1.default.createElement("button", { disabled: disabledRefundTypes.includes(option.key), key: option.key, className: 'margin-bottom-5 padding-5 width-100', style: { borderRadius: '5px', backgroundColor: isActive ? 'rgba(167, 107, 187, 0.1)' : '#FFFFFF' }, onClick: function () {
                            setRefundType(option.key);
                        } },
                        ((_a = option.opts) === null || _a === void 0 ? void 0 : _a.flag) && (react_1.default.createElement("div", { className: 'text-left text-brownish-grey padding-vertical-1', style: { letterSpacing: '2px', fontSize: '.8rem' } }, option.opts.flag.toUpperCase())),
                        react_1.default.createElement("div", { className: 'flex-container padding-vertical-5' },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("input", { type: 'radio', className: 'margin-bottom-0', checked: isActive, readOnly: true, style: { verticalAlign: 'middle' } })),
                            react_1.default.createElement("div", { className: 'text-left padding-left-5' },
                                react_1.default.createElement("div", null, option.name),
                                ((_b = option.opts) === null || _b === void 0 ? void 0 : _b.description) && (react_1.default.createElement("div", { className: 'padding-top-5 text-brownish-grey', style: { fontSize: '.8rem' } }, (_c = option.opts) === null || _c === void 0 ? void 0 : _c.description))))));
                });
            })()))));
});
